<template>
  <section>
    <pm-Breadcrumb :home="home" :model="items_bread" />

    <div class="col-md-12" style="margin-top:-15px;padding: 14px;" >
      <div class="row" >
        <div class="col-md-10">
          <h2 class="titulo-links-escolha">Dados Saúde Social</h2>
        </div>
      </div>

      <painelFiltro modelo="0" individual="1" @buscarRelatorio="buscarRelatorio" />

    </div>

    <div class="pm-card">

      n°, nome, data de nascimento, filiação, cpf, cns, sus

      <!--<div class="p-fluid formgrid grid" v-show="selecao.modelo ==='modelo01' && simples.turma_id >0 && pesquisar_modelo === true">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Aluno</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in this.relatorioALL" :key="r">
              <td>{{ r.nome +' '+ r.sobrenome }}</td>
              <td>
                <button class="btn btn-primary" @click="visualizarIndividual(r)" style="margin-top:10px;margin-right:5px;"
                  title="Visualizar">
                  Visualizar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    -->
    </div>

    <!--<pm-Dialog  header="Individual" v-model:visible="display_pdf" :style="{width: '100vw'}" :maximizable="true" :modal="true">
          <report v-if="aluno" :aluno="aluno"> </report>
      <template #footer>
      </template>
    </pm-Dialog>-->
  </section>
</template>

<script>
import { defineComponent } from "vue";
import axios from 'axios';
import { Escola } from "@/class/escolas";
import { SegmentoEscolar } from "@/class/segmentoEscolar.js";
import { Calendario } from "@/class/calendario";
import { Turma } from "@/class/turma";


import report from "./components/saudesocial"
import painelFiltro from "./components/filtros/painelFiltro.vue"

import { Relatorio } from './relatorio.service'

export default defineComponent ({
  components:{
    report,
    painelFiltro
  },
  data(){
    return{
      base_url: axios.defaults.baseURL.replace('/api/v1',''),
      home: {icon: 'pi pi-home', to: '/relatorios/saude-social'},
      items_bread: [
        {label: 'Saúde Social'},
      ],
    }
  },
  async beforeMount() {},
  methods: {
    async buscarFicha(){
      this.opentable = false;
      this.relatorioALL = [];
      this.aguardeLoading = true;
      this.pesquisar_modelo = true;
      const playload = {
        ano: this.simples.ano,
        turma_id: this.simples.turma_id,
        aluno_id: 0,
      };
      const res = await Relatorio.saudeSocial(playload,this.simples.individual);
      this.relatorioALL = res.data;
      this.aguardeLoading = false;
    },

    visualizarIndividual(n){
      this.aluno = [];
      this.aluno = n;
      this.display_pdf = true;
    },

    buscarRelatorio(info){
      console.log(info)
    }

  }
});
</script>

<style>

</style>
